module.exports = __webpack_public_path__ + "img/formHub.0b6945bb.png";